import { render, staticRenderFns } from "./categoryPurchaseProportion.vue?vue&type=template&id=2bd0b4f3&scoped=true"
import script from "./categoryPurchaseProportion.vue?vue&type=script&lang=js"
export * from "./categoryPurchaseProportion.vue?vue&type=script&lang=js"
import style0 from "./categoryPurchaseProportion.vue?vue&type=style&index=0&id=2bd0b4f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd0b4f3",
  null
  
)

export default component.exports